export default __webpack_public_path__ + "static/media/HP-D4-CW.9635bd01.png";